'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _colors = require('HubStyleTokens/colors');

var _reactRedux = require('react-redux');

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UICloseButton = require('UIComponents/button/UICloseButton');

var _UICloseButton2 = _interopRequireDefault(_UICloseButton);

var _PricingSelectors = require('../../../selectors/PricingSelectors');

var _pricingUtils = require('../../../utils/pricingUtils');

var _PriceDisplay = require('../../common/pricing/PriceDisplay');

var _PriceDisplay2 = _interopRequireDefault(_PriceDisplay);

var _ChargeTypes = require('self-service-api/constants/ChargeTypes');

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _merchandiseUtils = require('pricing-pages-unified-ui/utils/merchandiseUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShoppingCartItemContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ShoppingCartItem__ShoppingCartItemContainer'
})(['background-color:', ';padding:16px 24px;margin-bottom:8px;position:relative;'], _colors.GYPSUM);

var PlanTitle = _styledComponents2.default.div.withConfig({
  displayName: 'ShoppingCartItem__PlanTitle'
})(['font-weight:600;']);

var CloseButton = (0, _styledComponents2.default)(_UICloseButton2.default).withConfig({
  displayName: 'ShoppingCartItem__CloseButton'
})(['position:absolute;top:10px;right:10px;']);

function ShoppingCartItem(_ref) {
  var additionalUnitQuantity = _ref.additionalUnitQuantity,
      merchandiseId = _ref.merchandiseId,
      onRemove = _ref.onRemove,
      pricingDependencies = _ref.pricingDependencies,
      unit = _ref.unit;
  var currencyCode = pricingDependencies.currencyCode;

  var priceObject = (0, _pricingUtils.calculatePriceAndItemConfig)(_extends({}, pricingDependencies, {
    merchandiseId: merchandiseId,
    additionalUnitQuantity: additionalUnitQuantity
  }));
  var recurring = _ImmutableMerchandiseIdMap2.default[merchandiseId].chargeType === _ChargeTypes.RECURRING;
  var price = recurring ? priceObject.monthly.calculatedPrice : priceObject.oneTimeFee.calculatedPrice;

  return _react2.default.createElement(
    ShoppingCartItemContainer,
    null,
    _react2.default.createElement(
      PlanTitle,
      null,
      _react2.default.createElement(_FormattedMessage2.default, {
        message: 'pricing-pages.merchandise.' + (0, _merchandiseUtils.billingNameKey)(merchandiseId) + '.title'
      })
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_PriceDisplay2.default, { price: price, currencyCode: currencyCode }),
      recurring && _react2.default.createElement(_FormattedMessage2.default, {
        message: 'bundles.shoppingCart.perMonth',
        useGap: true
      }),
      unit && ' | ',
      unit
    ),
    _react2.default.createElement(
      CloseButton,
      { color: _colors.EERIE, onClick: onRemove, size: 'medium' },
      'x'
    )
  );
}

var mapState = function mapState(state) {
  return {
    pricingDependencies: (0, _PricingSelectors.pricingDependenciesSelector)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapState)(ShoppingCartItem);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/shopping-cart/ShoppingCartItem.js
// module id = 578
// module chunks = 3 4